import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { Form, Button, Dropdown } from 'semantic-ui-react';
import * as styles from './SignupForm.less';

const landingPagesOptions = [
  { key: '0', value: '10', text: '0-10' },
  { key: '1', value: '30', text: '11-30' },
  { key: '2', value: '50', text: '31-50' },
  { key: '3', value: '100', text: 'more than 50' },
];

const SignupStepFour = ({
  dirty,
  handleSubmit,
  isSubmitting,
  handleBlur,
  handleChange,
  values,
  errors,
}) => {
  const [landingPages, setlandingPages] = useState(values.landingPages);
  const landingPagesHandler = (e, { value }) => {
    values.landingPages = value;
    setlandingPages(values.landingPages);
  };

  return (
    <Fragment>
      <Form.Field>
        <label>How many landing- or sales pages do you work on?</label>
      </Form.Field>
      <Form.Field className={styles.formField}>
        <Dropdown
          placeholder='Number of landing pages'
          selection
          options={landingPagesOptions}
          className={styles.dropdown}
          value={landingPages || '10'}
          onChange={landingPagesHandler}
        />
      </Form.Field>
      <Form.Field>
        <label>What's the main problem you need to solve?</label>
      </Form.Field>
      <Form.Field className={styles.formField}>
        <Form.TextArea
          name='problem'
          type='problem'
          placeholder=''
          onBlur={handleBlur}
          value={values.problem || ''}
          onChange={handleChange}
          className={styles.inputOffset}
        />
      </Form.Field>
      <Form.Field>
        <Button
          onClick={handleSubmit}
          style={{ marginTop: '30px' }}
          disabled={!dirty || isSubmitting || Object.keys(errors).length !== 0}
          className={styles.signUpButton}
        >
          Complete signup
        </Button>
      </Form.Field>
    </Fragment>
  );
};

export default SignupStepFour;

SignupStepFour.propTypes = {
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  dirty: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  setFieldValue: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/views/components/SignupForm/SignupStepFour.js